import { render, staticRenderFns } from "./DashR.vue?vue&type=template&id=791333da"
import script from "./DashR.vue?vue&type=script&lang=js"
export * from "./DashR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports